module.exports = __webpack_public_path__ + "static/img/content-1.aa5337a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/content-1.png
// module id = hf2h
// module chunks = 1